import React, { useEffect, useState } from "react";
import { indexRole } from "../../../base/participants";
import ParticipantContent from "../../../base/participants/components/web/ParticipantContent";

function GroupParticipant({
    participant
}) {
    const [member, setMember] = useState();
    useEffect(() => {
        try {
            const list = [...participant.values()];

            list.sort((a,b) => indexRole.indexOf(a.role) - indexRole.indexOf(b.role));
            setMember(list);
        } catch (err) {
            console.log(err)
        }
        
    }, [participant]);

    return (
        <ParticipantContent participant={member} hover={false} />
    )
}

export default GroupParticipant;